<h2 mat-dialog-title>Add to Buyer Groups</h2>
<mat-dialog-content>
  <p>{{ nonBuyersWarning.buyers.length }} {{ nonBuyersWarning.buyers.length === 1 ? 'buyer' : 'buyers' }} selected.</p>

  <tc-non-buyers-warning
    #nonBuyersWarning
    [selectedCompanies]="data.selectedCompanies"
    (buyersChange)="buyers = $event"
  ></tc-non-buyers-warning>

  <tc-select-search
    [items]="buyerGroups"
    [ctrl]="groupCtrl"
    placeholder="Select Buyer Groups"
    bindLabel="name"
    bindValue="group_id"
    [multiple]="true"
  ></tc-select-search>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="add()" [disabled]="saving || !groupCtrl.value?.length || nonBuyersWarning.hasErrors || !buyers.length">Add</button>
</mat-dialog-actions>